/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material

// styles
import injectSheet from 'react-jss';
import styles from 'material/expandablesection/sectiondescription/sectiondescription_styles';


const SectionDescription = (props) => {
  const {
    main,
    additional
  } = props

  return <div className={`sectiondescription ${props.classes.sectiondescription}`}>
    <h5>{main}</h5>
    <h6>{additional}</h6>
    {props.content}
  </div>
}

export default injectSheet(styles)(SectionDescription)